<template>
    <div>
        <slot name="header" v-if="!noHeader">
            <div class="mb-2"><h3>{{ $t('Component(Verification):validity-of-declaration') }}</h3></div>
        </slot>
<!--        <v-select-->
<!--            id="declarationValidity"-->
<!--            v-model="declarationValidity"-->
<!--            :placeholder="placeholder"-->
<!--            :filterable="false"-->
<!--            label="title"-->
<!--            @input="onDeclarationValidityChange"-->
<!--            :options="declarationOfValidityOptions"-->
<!--            :clearable="false"-->
<!--        />-->
        <b-form-select
            :placeholder="placeholder"
            v-model="declarationValidity"
            :options="declarationOfValidityOptions"
            text-field="title"
            value-field="month"
            class="mt-1"
            @change="onDeclarationValidityChange"
        />
    </div>
</template>

<script>
import {BRow, BFormSelect} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    components: {
        BRow, BFormSelect
    },
    props: {
        noHeader: {
            type: Boolean,
            default: false
        },
        value: {
            default() {
                return { month: 6, title: '6 ' + this.$t('Component(Text):months') };
            }
        },
        placeholder: {
            default() {
                return this.$t('Component(DeclarationValidity):placeholder')
            }
        },
    },
    data() {
        return {
            declarationValidity: this.resolveDefaultValue(),
        };
    },
    methods: {
        onDeclarationValidityChange(value) {
            this.$emit('change', this.getOptionByMonth(value));
        },
        resolveDefaultValue() {
            if (Number.isInteger(this.value)) {
                const optionIndex = this.declarationOfValidityOptions.findIndex(o => o.month === this.value);
                if (optionIndex >= 0) {
                    return this.declarationOfValidityOptions[optionIndex];
                }
            }

            return this.value;
        },
        setDefault() {
            if (this.value === null && this.declarationOfValidityOptions && this.declarationOfValidityOptions.length > 0) {
                // this.declarationValidity = this.declarationOfValidityOptions[0]; // vue select
                this.declarationValidity = this.declarationOfValidityOptions[0].month; // select
                this.onDeclarationValidityChange(this.declarationValidity);
            }
        },
        setValueByMonth(month) {
            // this.declarationValidity = this.getOptionByMonth(month); // vue select
            this.declarationValidity = month; // select
        },
        getOptionByMonth(month) {
            const optionIndex = this.declarationOfValidityOptions.findIndex(o => o.month === month);
            if (optionIndex >= 0) {
                return this.declarationOfValidityOptions[optionIndex];
            }
            return null
        }
    },
    computed: {
        declarationOfValidityOptions() {
            return this.$store.getters.declarationOfValidityOptions;
        }
    }
}
</script>
